import { ApiSlugs, NotificationDto, NotificationId } from '@workspace/data-types';
import { Observable } from 'rxjs';
import { ApiCaller } from '../../api-caller.service';
import { ApiConnector } from '../../api-connector.abstract-service';

export class NotificationsConnector extends ApiConnector<NotificationDto, NotificationDto, NotificationId> {
  constructor(apiCaller: ApiCaller, apiPrefix: string) {
    super(apiCaller, apiPrefix, ApiSlugs.NOTIFICATIONS);
  }

  getNotifications(limit = 20, page = 0, unreadOnly?: boolean): Observable<NotificationDto[]> {
    const params: Record<string, string> = { limit: limit.toString(), page: page.toString() };
    if (unreadOnly !== undefined) {
      params['unreadOnly'] = unreadOnly.toString();
    }
    return this.apiCaller.getRequest<NotificationDto[]>(this.apiPrefix, `${this.slug}`, {
      params,
    });
  }

  getUnreadCount(): Observable<number> {
    return this.apiCaller.getRequest<number>(this.apiPrefix, `${this.slug}/unread-count`);
  }

  markAsRead(id: NotificationId): Observable<NotificationDto> {
    return this.apiCaller.patchRequest<NotificationDto>(this.apiPrefix, `${this.slug}/${id}/read`, {});
  }

  markAllAsRead(): Observable<boolean> {
    return this.apiCaller.patchRequest<boolean>(this.apiPrefix, `${this.slug}/read-all`, {});
  }

  getOneTimeToken(): Observable<{ token: string }> {
    return this.apiCaller.postRequest<{ token: string }>(this.apiPrefix, `${this.slug}/sse/token`, {});
  }

  getSseUrl(token: string): string {
    return this.apiCaller.buildUrl(this.apiPrefix, `${this.slug}/sse?token=${token}`);
  }
}
